<template>
  <a-modal
    ref="exportData"
    title="批量导出订单"
    :visible="visiblePopup"
    @cancel="handleCancel"
    width="800px"
  >
    <template slot="footer">
      <a-button key="back" @click="handleLook">查看已生成</a-button>
      <a-button key="submit" type="primary" @click="handleOk">确认导出</a-button>
    </template>
    <a-form :form="form">
      <a-form-item label="报表类型" v-bind="formItemLayout">
        <a-radio-group v-model="type" @change="onRadioChange">
          <a-radio :value="0">标准报表</a-radio>
          <a-radio :value="1" v-if="isCustom">自定义报表</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-if="type == 1" label="导出数据" v-bind="formItemLayout">
          <span class="check-box">
            <a-checkbox-group @change="onCheckboxChange">
              <a-checkbox v-for="item in exportDataList" :key="item.code"
                          :value="item.code">{{ item.name }}</a-checkbox>
            </a-checkbox-group>
          </span>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import formMixins from '../../utils/mixins/formMixins'

export default {
  name: 'ExportTableData',
  mixins: [formMixins],
  props: {
    visiblePopup: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      default: {}
    },
    exportReportType: {  //1订单 0是商品
      type: Number,
      default: 0
    },
    isCustom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: 0,
      exportDataList: [],
      checkedValues: ''
    }
  },
  mounted() {
    this.getExportReportField()
    this.getLogUtils().logWithTag('queryParams', this.queryParams)
  },
  methods: {
    onCheckboxChange(checkedValues) {
      this.getLogUtils().logWithTag('checked = ', checkedValues)
      let strArr = checkedValues
      this.checkedValues = strArr.join(',')
    },
    handleCancel(e) {
      this.$emit('childCloseDialog')
    },
    onRadioChange(e) {
      this.getLogUtils().logWithTag(`checked = ${e.target.value}`)
      this.type = e.target.value
    },
    handleOk(e) {
      this.getLogUtils().logWithTag(`handleOk =`, e)
      this.exportData()
    },
    // 查看已生产报表
    handleLook() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    // 导出
    exportData() {
      this.queryParams.exportType = this.type
      if (this.type == 0) {
        this.queryParams.exportField = ''
      } else {
        this.queryParams.exportField = this.checkedValues
      }
      this.getLogUtils().logWithTag('导出参数', this.queryParams)
      if (this.exportReportType == 0) {
        this.getHttpServices().getProService().post('api/v2/productManage/exportProductList', this.queryParams)
          .then(res => {
            this.getLogUtils().logWithTag('==exportDataList==', res)
            this.$message.success('操作成功')
            this.handleCancel()
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else if (this.exportReportType == 1) {
        const url = 'order/v3/exportOrderList'
        this.getHttpServices().getMemberAuthService().post(url, this.queryParams)
          .then(res => {
            this.getLogUtils().logWithTag('==exportDataList==', res)
            this.$message.success('操作成功')
            this.handleCancel()
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    // 获取自定义报表数据
    getExportReportField() {
      if (this.exportReportType == 0) {
        this.getHttpServices().getUserService().get('api/v2/merchant/getExportReportField?exportReportType=' + this.exportReportType)
          .then(res => {
            this.getLogUtils().logWithTag('==getExportReportField==', res)
            this.exportDataList = res
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.getHttpServices().getMemberAuthService().get('order/v3/getExportReportField?exportReportType=' + this.exportReportType)
          .then(res => {
            this.getLogUtils().logWithTag('==getExportReportField==', res)
            this.exportDataList = res
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less">
.check-box {
  .ant-checkbox-wrapper {
    margin-left: 8px;
  }
}
</style>